import {
  Wallet,
  Eye,
  Gauge,
  TrendingUp,
  Webhook,
  Award,
  type LucideIcon,
} from "lucide-react";

export type LandingFeature = {
  id: string;
  icon: LucideIcon;
  titleKey: string;
  bodyKey: string;
};

export const LANDING_FEATURES: LandingFeature[] = [
  {
    id: "affordable",
    icon: Wallet,
    titleKey: "features.items.affordable.title",
    bodyKey: "features.items.affordable.body",
  },
  {
    id: "transparency",
    icon: Eye,
    titleKey: "features.items.transparency.title",
    bodyKey: "features.items.transparency.body",
  },
  {
    id: "evaluation",
    icon: Gauge,
    titleKey: "features.items.evaluation.title",
    bodyKey: "features.items.evaluation.body",
  },
  {
    id: "improvement",
    icon: TrendingUp,
    titleKey: "features.items.improvement.title",
    bodyKey: "features.items.improvement.body",
  },
  {
    id: "deployment",
    icon: Webhook,
    titleKey: "features.items.deployment.title",
    bodyKey: "features.items.deployment.body",
  },
  {
    id: "experts",
    icon: Award,
    titleKey: "features.items.experts.title",
    bodyKey: "features.items.experts.body",
  },
];
